module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('md-card', {
    staticClass: "card",
    staticStyle: {
      "margin": "1rem"
    }
  }, [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('h3', [_c('b', [_vm._v("Item MIS Report")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (
    (_vm.itemMaster.itemId > 0 && _vm.$sessionsStorage.get('designation') == 'Admin') ||
    _vm.$sessionsStorage.get('designation') == 'HOD'
  ) ? _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "itemName",
      "name": "itemName",
      "disabled": _vm.itemMaster.itemId == '' ? false : true
    },
    model: {
      value: (_vm.itemMaster.itemName),
      callback: function($$v) {
        _vm.$set(_vm.itemMaster, "itemName", $$v)
      },
      expression: "itemMaster.itemName"
    }
  })], 1), _vm._v(" "), (!_vm.itemMaster.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.itemNameError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Part Number "), _c('span', {
    staticClass: "error mb-1"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "part_number",
      "name": "part_number",
      "disabled": _vm.itemMaster.itemId == '' ? false : true
    },
    model: {
      value: (_vm.itemMaster.part_number),
      callback: function($$v) {
        _vm.$set(_vm.itemMaster, "part_number", $$v)
      },
      expression: "itemMaster.part_number"
    }
  })], 1), _vm._v(" "), (!_vm.itemMaster.part_number) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.partNumberError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "2"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Stocked-In Quantity "), _c('span', {
    staticClass: "error mb-1"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "formatter": _vm.capitalizeAll,
      "id": "quantity",
      "name": "quantity"
    },
    model: {
      value: (_vm.itemMaster.quantity),
      callback: function($$v) {
        _vm.$set(_vm.itemMaster, "quantity", $$v)
      },
      expression: "itemMaster.quantity"
    }
  })], 1), _vm._v(" "), (!_vm.itemMaster.quantity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.quantityError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Rate Per Quantity "), _c('span', {
    staticClass: "error mb-1"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "1",
      "id": "ratePerUnit",
      "name": "ratePerUnit"
    },
    model: {
      value: (_vm.itemMaster.ratePerUnit),
      callback: function($$v) {
        _vm.$set(_vm.itemMaster, "ratePerUnit", $$v)
      },
      expression: "itemMaster.ratePerUnit"
    }
  })], 1), _vm._v(" "), (!_vm.itemMaster.ratePerUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ratePerUnitError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-5 mb-1",
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    staticClass: "py-2",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("\n              " + _vm._s(_vm.itemMaster.itemId == "" ? "Add New Item" : "Update Item") + "\n            ")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-5 mb-1",
    attrs: {
      "md": "1"
    }
  }, [(_vm.itemMaster.itemId != '' && _vm.itemMaster.unit == 'pcs') ? _c('b-button', {
    staticClass: "py-2",
    attrs: {
      "variant": "info",
      "id": "quantityDetailsButton",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openQuantityModal(_vm.itemMaster.itemId, 'yes')
      }
    }
  }, [_vm._v("\n              Sub-Item Details\n            ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "Item-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "title": "Sub Item List",
      "centered": ""
    }
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openQuantityModal(_vm.itemMaster.itemId, '')
      }
    }
  }, [_vm._v("\n              All Items\n            ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openQuantityModal(_vm.itemMaster.itemId, 'yes')
      }
    }
  }, [_vm._v("\n              Show Only Stocked-In items\n            ")]), _vm._v(" "), _c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search sub Item"
    },
    model: {
      value: (_vm.subItemfilter),
      callback: function($$v) {
        _vm.subItemfilter = $$v
      },
      expression: "subItemfilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.subItemfilter
    },
    on: {
      "click": function($event) {
        _vm.subItemfilter = ''
      }
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRowsSubItem) + " Sub Items")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.subItemList,
      "fields": _vm.subItemfields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPageSubItem,
      "filter": _vm.subItemfilter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onSubItemFiltered
    },
    scopedSlots: _vm._u([{
      key: "itemId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPageSubItem))])]
      }
    }, {
      key: "subItemName",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.sub_item_name))])]
      }
    }, {
      key: "serialNo",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.sub_item_code))])]
      }
    }, {
      key: "installationDate",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.installation_date))])]
      }
    }, {
      key: "manufacturingDate",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.manufacture_date))])]
      }
    }, {
      key: "expiryDate",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.expiry_date))])]
      }
    }, {
      key: "stockReceivedDate",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.sub_item_received_date))])]
      }
    }, {
      key: "stockReceivedBy",
      fn: function(row7) {
        return [_c('span', [_vm._v(_vm._s(row7.item.receivedBy))])]
      }
    }, {
      key: "stockoutdate",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.sub_item_stockout_date))])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRowsSubItem,
      "per-page": _vm.perPageSubItem
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Item Details")])]), _vm._v(" "), _c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Item Name / Item Detail Here"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusVal",
      "option-text": "statusText",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.viewitemDetail('Normal')
      }
    },
    model: {
      value: (_vm.itemStatusFilter),
      callback: function($$v) {
        _vm.itemStatusFilter = $$v
      },
      expression: "itemStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "md-2 mb-3",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.StockTransfer()
      }
    }
  }, [_vm._v("\n                  Stock Transfer\n                ")]), _vm._v(" "), _c('b-button', {
    staticClass: "md-2 mb-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.viewitemDetail('Excel')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.ExcelBtnName) + "\n                  "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "md-2 mb-3 ml-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName1 != 'Export SubItem As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getExportExcelSubItemList()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.ExcelBtnName1) + "\n                  "), (_vm.ExcelBtnName1 != 'Export SubItem As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Items")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.stockList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "itemId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "itemName",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.itemName))]), _vm._v(" "), _c('br'), _vm._v(" "), (row2.item.unit == 'pcs' && row2.item.itemId) ? _c('b-button', {
          staticClass: "py-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "primary",
            "size": "sm",
            "id": "addButtonLoader"
          },
          on: {
            "click": function($event) {
              _vm.openUpdateSubItemModal(row2.item)
            }
          }
        }, [_vm._v("\n                  Sub Item's\n                ")]) : _vm._e()]
      }
    }, {
      key: "itemCategory",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.item_category))])]
      }
    }, {
      key: "partNumber",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.part_number))])]
      }
    }, {
      key: "sparePartLocation",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.spare_part_location))])]
      }
    }, {
      key: "loc_name",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.loc_name))])]
      }
    }, {
      key: "work_loc_name",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.work_loc_name))])]
      }
    }, {
      key: "ratePerUnit",
      fn: function(row7) {
        return [_c('span', [_vm._v(_vm._s(row7.item.FirstpoRatePerUnit == "" ?
          row7.item.ratePerUnit :
          row7.item.ratePerUnit ?
          row7.item.ratePerUnit :
          row7.item.FirstpoRatePerUnit))])]
      }
    }, {
      key: "unit",
      fn: function(row14) {
        return [_c('span', [_vm._v(_vm._s(row14.item.unit))])]
      }
    }, {
      key: "quantityAvailable",
      fn: function(row8) {
        return [(
          parseInt(row8.item.quantity) - parseInt(row8.item.stockOutNumber) >
          0
        ) ? _c('span', [_vm._v(_vm._s(parseInt(row8.item.stockOutNumber) == 0 ?
          row8.item.quantity :
          parseInt(row8.item.quantity) -
          parseInt(row8.item.stockOutNumber)))]) : _c('span', {
          staticClass: "error"
        }, [_c('b', [_vm._v("Out of stock")])])]
      }
    }, {
      key: "totalStockIn",
      fn: function(row9) {
        return [_c('span', [_vm._v(_vm._s(row9.item.quantity))])]
      }
    }, {
      key: "stockOutNumber",
      fn: function(row10) {
        return [_c('span', [_vm._v(_vm._s(row10.item.stockOutNumber ? row10.item.stockOutNumber : 0))])]
      }
    }, {
      key: "maintenanceType",
      fn: function(row11) {
        return [_c('span', [_vm._v(_vm._s(row11.item.maintenance_type))])]
      }
    }, {
      key: "remarks",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s(row12.item.remarks))])]
      }
    }, {
      key: "view",
      fn: function(row13) {
        return [(row13.item.stockLogArr.length > 0) ? _c('b-button', {
          staticClass: "pull-right ml-1 mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "disabled": row13.item.stockLogArr.length <= 0 ? true : false,
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.StockItemTransfer('stocklog', row13.item)
            }
          }
        }, [_vm._v("Stock Transfer History")]) : _vm._e(), _vm._v(" "), (row13.item.logArr.length > 0) ? _c('b-button', {
          staticClass: "pull-right ml-1 mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "disabled": row13.item.logArr.length <= 0 ? true : false,
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.StockItemTransfer('itemlog', row13.item)
            }
          }
        }, [_vm._v("Item Log History")]) : _vm._e(), _vm._v(" "), (
          _vm.$sessionsStorage.get('designation') == 'Admin' ||
          _vm.$sessionsStorage.get('designation') == 'HOD'
        ) ? _c('md-button', {
          staticClass: "md-icon-button md-raised md-dense",
          on: {
            "click": function($event) {
              _vm.viewItemPage(row13.item.itemId)
            }
          }
        }, [_c('md-icon', [_vm._v("edit")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Sub-Item-Modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Sub Item List'
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.PS_subItemList,
      "fields": _vm.PS_subItemFields
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1))])]
      }
    }, {
      key: "is_quanity",
      fn: function(row1) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row1.item.lead_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row1.item.lead_id,
            "name": "approval",
            "value": row1.item.is_quanity == 1 ? true : false,
            "disabled": true
          },
          on: {
            "change": function($event) {
              _vm.isQuanityMinus(row1.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.is_quanity == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row1.item.is_quanity == 1 ? "Done" : "Pending"))])], 1)])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "xs"
    },
    on: {
      "click": _vm.hideSubItemModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Stock-Transfer-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Stock Transfer"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.ItemStockModal.itemId && _vm.errorStockItemList.itemId ? 'red' : '',
    }),
    attrs: {
      "list": _vm.stockList,
      "option-value": "itemId",
      "option-text": "itemName",
      "placeholder": "Select Item"
    },
    on: {
      "input": function($event) {
        _vm.getItemData(_vm.ItemStockModal.itemId)
      }
    },
    model: {
      value: (_vm.ItemStockModal.itemId),
      callback: function($$v) {
        _vm.$set(_vm.ItemStockModal, "itemId", $$v)
      },
      expression: "ItemStockModal.itemId"
    }
  }), _vm._v(" "), (!_vm.ItemStockModal.itemId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorStockItemList.itemId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("From Location"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.ItemStockModal.fk_old_loc_id && _vm.errorStockItemList.fk_old_loc_id ?
        'red' :
        '',
    }),
    attrs: {
      "isDisabled": true,
      "list": _vm.$store.getters['common/getAllBranchList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": " Location"
    },
    on: {
      "input": function($event) {
        _vm.getStockLocDetails(_vm.ItemStockModal.fk_old_loc_id)
      }
    },
    model: {
      value: (_vm.ItemStockModal.fk_old_loc_id),
      callback: function($$v) {
        _vm.$set(_vm.ItemStockModal, "fk_old_loc_id", $$v)
      },
      expression: "ItemStockModal.fk_old_loc_id"
    }
  }), _vm._v(" "), (!_vm.ItemStockModal.fk_old_loc_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorStockItemList.fk_old_loc_id))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Old Quantity"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.ItemStockModal.old_quantity && _vm.errorStockItemList.old_quantity ?
        'red' :
        '',
    }),
    attrs: {
      "disabled": "",
      "type": "number",
      "min": "0",
      "formatter": _vm.capitalizeAll,
      "id": "old_quantity",
      "name": "old_quantity"
    },
    model: {
      value: (_vm.ItemStockModal.old_quantity),
      callback: function($$v) {
        _vm.$set(_vm.ItemStockModal, "old_quantity", $$v)
      },
      expression: "ItemStockModal.old_quantity"
    }
  }), _vm._v(" "), (!_vm.ItemStockModal.old_quantity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorStockItemList.old_quantity))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Old Rate Per Unit"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.ItemStockModal.ratePerUnit && _vm.errorStockItemList.ratePerUnit ?
        'red' :
        '',
    }),
    attrs: {
      "disabled": "",
      "type": "number",
      "min": "0",
      "formatter": _vm.capitalizeAll,
      "id": "ratePerUnit",
      "name": "ratePerUnit"
    },
    model: {
      value: (_vm.ItemStockModal.ratePerUnit),
      callback: function($$v) {
        _vm.$set(_vm.ItemStockModal, "ratePerUnit", $$v)
      },
      expression: "ItemStockModal.ratePerUnit"
    }
  }), _vm._v(" "), (!_vm.ItemStockModal.ratePerUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorStockItemList.ratePerUnit))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Location"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor:
        !_vm.ItemStockModal.fk_loc_id && _vm.errorStockItemList.fk_loc_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": " Location"
    },
    on: {
      "input": function($event) {
        _vm.getStockLocDetails(_vm.ItemStockModal.fk_loc_id)
      }
    },
    model: {
      value: (_vm.ItemStockModal.fk_loc_id),
      callback: function($$v) {
        _vm.$set(_vm.ItemStockModal, "fk_loc_id", $$v)
      },
      expression: "ItemStockModal.fk_loc_id"
    }
  }), _vm._v(" "), (!_vm.ItemStockModal.fk_loc_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorStockItemList.fk_loc_id))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Quantity"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.ItemStockModal.quantity && _vm.errorStockItemList.quantity ? 'red' : '',
    }),
    attrs: {
      "type": "number",
      "min": "0",
      "formatter": _vm.capitalizeAll,
      "id": "quantity",
      "name": "quantity"
    },
    model: {
      value: (_vm.ItemStockModal.quantity),
      callback: function($$v) {
        _vm.$set(_vm.ItemStockModal, "quantity", $$v)
      },
      expression: "ItemStockModal.quantity"
    }
  }), _vm._v(" "), (!_vm.ItemStockModal.quantity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorStockItemList.quantity))]) : _vm._e()], 1), _vm._v(" "), (_vm.ItemStockModal.LocationErr) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.ItemStockModal.LocationErr) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.ItemStockModal.LocationErr) + "\n        ")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.ItemDisabled,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.saveStockTransfer
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideStockTransferModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Stock-Item-Modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.StockModalType + ' List'
    }
  }, [_c('b-row', [(_vm.StockModalType == 'Stock Transfer Log History') ? _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "responsive": "",
      "primary-key": "id_email_section",
      "filter": _vm.filter,
      "show-empty": "",
      "stacked": "md",
      "items": _vm.stockLogArr,
      "fields": _vm.StockLogFields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1))])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.StockModalType == 'Item Log History') ? _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "responsive": "",
      "primary-key": "id_email_section",
      "filter": _vm.filter,
      "show-empty": "",
      "stacked": "md",
      "items": _vm.logArr,
      "fields": _vm.logFields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1))])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "xs"
    },
    on: {
      "click": _vm.hideStockItemModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a07ab2e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/maintenance/itemMaster/itemMisRep.vue
// module id = 2818
// module chunks = 0